module.exports = __webpack_public_path__ + "img/大数据分析.46aec46e.png";